<div style="display: block">
  <canvas
    baseChart
    [data]="doughnutChartData"
    [labels]="doughnutChartLabels"
    [chartType]="doughnutChartType"
    height="200px"
    [colors]="doghnutColors"
  ></canvas>
</div>
